import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaClipboardList } from "react-icons/fa6";
import { FaPrayingHands } from "react-icons/fa";
import AttendanaceLayout from "../../components/AttendanceLayout/AttendanaceLayout";
import { BiSolidReport } from "react-icons/bi";

export default function AttendanceWorkerDashboard() {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location?.state || {};
  
  useEffect(() => {
    const refreshToken = localStorage.getItem("refreshToken");
    if (!refreshToken) {
      navigate("/");
    }
  }, [navigate]);

    useEffect(() => {
      // Listen for back navigation
      const handleBeforeUnload = () => {
        localStorage.clear();
      };
  
      // Adding event listener for back navigation
      window.addEventListener('popstate', handleBeforeUnload);
  
      // Cleanup on component unmount
      return () => {
        window.removeEventListener('popstate', handleBeforeUnload);
      };
    }, [navigate]);

  useEffect(() => {
    if (!localStorage.getItem("alertShown")) {
      toast.success("Login successfully");
      localStorage.setItem("alertShown", "true");
    }
  }, []);

  return (
    <AttendanaceLayout ac1="active">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h4 className="m-0 text-dark">Dashboard</h4>
            </div>
          </div>
        </div>
      </div>
      <section className="content mb-4">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-sm-6 col-md-4">
              <Link to="/take-attendance" className="text-dark" state={{ id: id }}>
                <div className="info-box mb-3">
                  <span className="info-box-icon bg-primary elevation-1">
                    <FaClipboardList />
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text pb-1 ">Take Attendance</span>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-12 col-sm-6 col-md-4">
              <Link to="/register-haribhakt" className="text-dark ">
                <div className="info-box mb-3">
                  <span className="info-box-icon bg-info elevation-1">
                    <FaPrayingHands />
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text pb-1 ">Register Haribhakt</span>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-12 col-sm-6 col-md-4">
              <Link to="/sabha-report4" className="text-dark ">
                <div className="info-box mb-3">
                  <span className="info-box-icon bg-secondary elevation-1">
                    <BiSolidReport />
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text pb-1 ">Sabha Report</span>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-12 col-sm-6 col-md-4">
              <Link to="/parasabha-report4" className="text-dark ">
                <div className="info-box mb-3">
                  <span className="info-box-icon bg-warning elevation-1">
                    <FaClipboardList />
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text pb-1 ">Para Sabha Report</span>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer />
    </AttendanaceLayout>
  );
}
